import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class K0CalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (K0CalculationMethodModel._instance == null) K0CalculationMethodModel._instance = new K0CalculationMethodModel(authManager);
        return K0CalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/k-0-calculation-methods', 'geo-sections/k-0-calculation-methods/codelist');

        this.entityName = 'geo-sections.K0CalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'K 0 Method';
        this.setLabel = 'K 0 Methods';

        this.browser = {
            name: 'default-geo-sections-k0calculationmethod-browser',
            moduleName: 'default-geo-sections-k0calculationmethod-browser',
            moduleTitle: 'K 0 Methods',
            moduleStateSlotName: 'default-geo-sections-k0calculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-k0calculationmethod-editor',
            moduleName: 'default-geo-sections-k0calculationmethod-editor',
            moduleTitle: 'K 0 Method',
            moduleStateSlotName: 'default-geo-sections-k0calculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
            {
                name: 'isDefault',
                type: 'bool',
                persistent: true,
                label: 'Is Default',
            },
        ];

    }

}
